export const RENAME_FROM = 'fusionsafety'
export const RENAME_SEEN_KEY = 'archestor-rename-seen'

// The redirect appends http.request.uri.path, so the homepage arrives as "fusionsafety/".
export function isRenameFromValue(value: unknown): boolean {
  return value === RENAME_FROM || value === `${RENAME_FROM}/`
}

export const renamePendingScript = `(function(){try{var from=new URLSearchParams(location.search).get('from')||'';if((from==='${RENAME_FROM}'||from==='${RENAME_FROM}/')&&localStorage.getItem('${RENAME_SEEN_KEY}')!=='1'){document.documentElement.classList.add('rename-pending')}}catch(e){}})();`
